<template>
  <faqs use-filter :audiences="[0,3]"></faqs>
</template>

<script>
import Faqs from "@components/shared/Faqs";
export default {
  name: "FaqsApplicants",
  components: {
    Faqs
  }
}
</script>

<style scoped>

</style>